export default __webpack_public_path__ + "images/models/65acf6a13be11b5a39ca076bd24caafe.glb";